import React from 'react'

import classes from './layout.css'

const ModuleThree = (props) => {
	return (
		<div className={classes.Container}>
			<h3><u><strong>INFORMED CONSENT</strong></u></h3>
			<p>I have viewed the OMS informed consent video this date regarding the {props.content} provided by OMSNIC (Oral Maxillofacial Surgery National Insurance Company).</p>
			<p>I understand the information presented therein and any questions or concerns regarding my surgical procedure have been explained to me.</p>
		</div>
	)
}

export default ModuleThree


// WEBPACK FOOTER //
// ./src/components/Modules/3.js